export enum OnboardingFormButtonState {
  NORMAL = 'normal',
  DISABLED = 'disabled',
}
